export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: "/",
    },
    {
        id: 3,
        label: "menuitems.users.text",
        icon: "bx-user",
        link: "users",
    },
    {
        id: 4,
        label: "menuitems.feedbacks.text",
        icon: "bx-message-dots",
        link: "feedbacks",
    },
    {
        id: 5,
        label: "menuitems.libraries.text",
        icon: "bx-images",
        link: "libraries",
    },

];

